import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { DialogHeader, DialogMain } from '../../../../shared/components/dialog';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { setHash } from '../../../../shared/router/hash/hashHistory';
import { IBooking } from '../../../domain/booking/models/IBooking';
import { trackGuestBookingError } from '../../booking-steps/shared/analytics/custom/trackGuestBookingError';
import { ApiErrorMessage } from '../../errors/ApiErrorMessage';
import { getBookingDetailsHash } from '../details';
import { GuestBookingForm } from './GuestBookingForm';
import { useAddGuestBookingSubmit } from './hooks/useAddGuestBookingSubmit';

export const AddGuestBookingDialog = observer(() => {
	const { t } = useTranslation();
	const [error, setError] = useState<Error | undefined>(undefined);

	const handleSuccess = (booking: IBooking) => {
		setHash(getBookingDetailsHash(booking.reference));
	};
	const { onSubmit } = useAddGuestBookingSubmit({
		onSuccess: handleSuccess,
		onError: setError,
	});

	return (
		<>
			<DialogHeader title={t('parking_retrieve_guest_booking_header')} />
			{
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				/* @ts-ignore */
			}
			<DialogMain>
				<GuestBookingForm
					onSubmit={onSubmit}
					submitButtonText={t('parking_retrieve_guest_booking_button_title')}
				/>
			</DialogMain>
			{error && <AddGuestBookingError error={error} />}
		</>
	);
});

const AddGuestBookingError = ({ error }: { error: Error }) => {
	const { t } = useTranslation();
	trackGuestBookingError(t('parking_retrieve_booking_generic_error'));

	return (
		<ApiErrorMessage
			error={error}
			genericMessage="parking_retrieve_booking_generic_error"
		/>
	);
};
